<template>
  <div>

    <b-form @submit="onSubmit" class="b-white p-5 rounded b-shadow">
      <p class="text-center h4 mb-3" style="color: #ed8f00 !important;">
        ¡Completa la información para continuar con la experiencia kllaar.com!
      </p>
      <h4 class="font-blue">Empresa</h4>
      <hr>

       <b-form-group v-if="exist_email==0">
         <label>Correo electrónico <b class="font-orange">*</b></label>
        <b-form-input v-model="form.email" type="email" required placeholder="Ingresa tu cuenta de correo">
        </b-form-input>
        <b-form-invalid-feedback :state="false" v-if="this.response.email">
          {{this.response.email[0]}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group>
         <label>Nombre de la Empresa <b class="font-orange">*</b></label>
        <b-form-input v-model="form.enterprise" type="text" required placeholder="Ingresa el nombre de tu empresa">
        </b-form-input>
        <b-form-invalid-feedback :state="false" v-if="this.response.enterprise">
          {{this.response.enterprise[0]}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group>
        <label>RFC <b class="font-orange">*</b></label>
        <b-form-input v-model="form.rfc" type="text" required placeholder="RFC"></b-form-input>
        <b-form-invalid-feedback :state="false" v-if="this.response.rfc">
          {{this.response.rfc[0]}}
        </b-form-invalid-feedback>
      </b-form-group>


      <b-form-group label="Sitio Web">
        <b-form-input type="text" v-model="form.website" placeholder="https://"></b-form-input>
      </b-form-group>
      <b-form-group label="LinkedIn">
        <b-form-input type="text" v-model="form.url_linkedIn" placeholder="https://www.linkedin.com/"></b-form-input>
      </b-form-group>
      <b-form-group label="Facebook">
        <b-form-input type="text" v-model="form.url_facebook" placeholder="https://www.facebook.com/"></b-form-input>
      </b-form-group>

      <b-form-group>
        <label>¿Cómo te enteraste de Kllaar.com? <b class="font-orange">*</b></label>
        <b-form-select
            id="input-3"
            v-model="form.how"
            :options="como"
            required
        ></b-form-select>
      </b-form-group>
      <b-form-group label="" v-if="form.how == 'Otro'">
        <b-form-input type="text" required placeholder="¿Cómo te enteraste?"></b-form-input>
      </b-form-group>

      <b-form-group>
        <b-form-checkbox-group v-model="form.notificaciones" id="checkboxes-4">
          <b-form-checkbox value="acepto">Deseo recibir comunicados, publicidad desarrollados por Kllaar.
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>

      <b-button type="submit" class="b-orange col-sm-12" :disabled="loading">
        Continuar
        <b-spinner v-if="loading" small label="Espere ..."></b-spinner>
      </b-button>

    </b-form>

  </div>


</template>
<script>

export default {
  name: 'fromEnterprise',
  props:['exist_email'],
  data () {
    return {
      loading: false,
      como: [{text: 'Selecciona una opción', value: null}, 'Un amigo', 'Internet', 'Redes Sociales', 'Otro'],
      giro: [{text: 'Selecciona una opción', value: null}, 'Giro A', 'Giro B', 'Giro C', 'Giro D'],
      form: {
        account: 'enterprise',
        name: '',
        lname: '',
        enterprise: '',
        rfc: '',
        email: '',
        password: '',
        password_confirmation: '',
        website: '',
        url_linkedIn: '',
        url_facebook: '',
        how: null,
        notificaciones: []
      },
      response: {}
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      this.loading = true
      this.$bus.$emit('registerEnterprise', this.form)
    },
  },
  created() {
    this.$bus.$on('registerEnterpriseResponse', (data)=>{
      this.loading = false
      this.response = data
    })
  }
}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/#pages/validate/pages/formEnterprise.vue